/* ═══════════════════════════════════════════════════════════
   FÉLIX · Versión A — JS compartido
   En Shopify, el carrito demo se reemplaza por el carrito nativo
   y el formulario por el form de contacto de Shopify o Web3Forms.
   ═══════════════════════════════════════════════════════════ */
(function(){
  'use strict';

  /* ── Loader ─────────────────────────────────────────── */
  var quitar = function(){ document.body.classList.add('cargado'); };
  window.addEventListener('load', function(){ setTimeout(quitar, 420); });
  setTimeout(quitar, 2600); // red de seguridad

  /* ── Header + botón subir ───────────────────────────── */
  var header = document.getElementById('header');
  var subir  = document.getElementById('subir');
  var alScroll = function(){
    var y = window.scrollY;
    if(header) header.classList.toggle('compacto', y > 40);
    if(subir)  subir.classList.toggle('visible', y > 620);
  };
  window.addEventListener('scroll', alScroll, {passive:true});
  alScroll();
  if(subir) subir.addEventListener('click', function(){ window.scrollTo({top:0, behavior:'smooth'}); });

  /* ── Menú móvil ─────────────────────────────────────── */
  var menuBtn = document.getElementById('menuBtn');
  var nav = document.getElementById('nav');
  if(menuBtn && nav){
    menuBtn.addEventListener('click', function(){
      var abierto = nav.classList.toggle('abierto');
      menuBtn.classList.toggle('activo', abierto);
      menuBtn.setAttribute('aria-expanded', abierto);
      document.body.style.overflow = abierto ? 'hidden' : '';
    });
    nav.addEventListener('click', function(e){
      if(e.target.tagName === 'A'){
        nav.classList.remove('abierto');
        menuBtn.classList.remove('activo');
        menuBtn.setAttribute('aria-expanded','false');
        document.body.style.overflow = '';
      }
    });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && nav.classList.contains('abierto')) menuBtn.click();
    });
  }

  /* ── Reveals ────────────────────────────────────────── */
  var elems = document.querySelectorAll('.reveal');
  if('IntersectionObserver' in window){
    var obs = new IntersectionObserver(function(entradas){
      entradas.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, {threshold:.12, rootMargin:'0px 0px -60px 0px'});
    elems.forEach(function(el){ obs.observe(el); });
  } else {
    elems.forEach(function(el){ el.classList.add('visible'); });
  }


  /* ── Filtros de catálogo / puntos de venta ──────────── */
  document.querySelectorAll('[data-filtros]').forEach(function(grupo){
    var destino = document.querySelector(grupo.getAttribute('data-filtros'));
    if(!destino) return;
    grupo.addEventListener('click', function(e){
      var btn = e.target.closest('.filtro');
      if(!btn) return;
      grupo.querySelectorAll('.filtro').forEach(function(b){ b.classList.remove('activo'); });
      btn.classList.add('activo');
      var cat = btn.getAttribute('data-cat');
      destino.querySelectorAll('[data-cat]').forEach(function(item){
        var coincide = (cat === 'todo') || (item.getAttribute('data-cat') === cat);
        item.classList.toggle('oculto', !coincide);
      });
    });
  });

  /* ── Newsletter + formulario (demo) ─────────────────── */
  document.querySelectorAll('form[data-demo]').forEach(function(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      if(form.querySelector('.hp') && form.querySelector('.hp').value) return; // honeypot
      var b = form.querySelector('button[type="submit"], button:not([type])');
      if(!b) return;
      var t = b.textContent;
      b.textContent = '¡Listo! Gracias';
      form.reset();
      setTimeout(function(){ b.textContent = t; }, 2600);
    });
  });
})();

/* ── PDP: galería, cantidad, chips (Versión B) ─────────── */
(function(){
  'use strict';
  var galImg = document.getElementById('galImg');
  if(galImg){
    document.querySelectorAll('.miniaturas button').forEach(function(b){
      b.addEventListener('click', function(){
        document.querySelectorAll('.miniaturas button').forEach(function(x){ x.classList.remove('activa'); });
        b.classList.add('activa');
        galImg.src = b.getAttribute('data-img');
      });
    });
  }
  var cant = document.getElementById('cant');
  if(cant){
    var n = 1;
    document.querySelector('[data-mas]').addEventListener('click', function(){ n++; cant.textContent = n; act(); });
    document.querySelector('[data-menos]').addEventListener('click', function(){ if(n>1){ n--; cant.textContent = n; act(); } });
    var act = function(){
      var btn = document.querySelector('.agregar-pdp');
      if(btn) btn.textContent = 'Agregar al carrito — $' + (49*n);
    };
  }
  document.querySelectorAll('[data-chips]').forEach(function(g){
    g.addEventListener('click', function(e){
      var c = e.target.closest('.chip'); if(!c) return;
      g.querySelectorAll('.chip').forEach(function(x){ x.classList.remove('activo'); });
      c.classList.add('activo');
    });
  });
  document.querySelectorAll('.agregar-pdp,.add,.add-bundle').forEach(function(btn){
    btn.addEventListener('click', function(){
      if(btn.getAttribute('data-key') || btn.classList.contains('agregar')) return; // carrito.js se encarga
      var c = document.getElementById('contador');
      if(c) c.textContent = parseInt(c.textContent||'0',10)+1;
      var t = btn.textContent;
      btn.textContent = 'Agregado ✓';
      setTimeout(function(){ btn.textContent = t; }, 1300);
    });
  });
})();

/* ── PDP: galería y cantidad ─────────────────────────── */
(function(){
  'use strict';
  var principal = document.getElementById('fotoPrincipal');
  if(principal){
    document.querySelectorAll('.thumb').forEach(function(th){
      th.addEventListener('click', function(){
        document.querySelectorAll('.thumb').forEach(function(x){x.classList.remove('activo');});
        th.classList.add('activo');
        principal.src = th.getAttribute('data-img');
        var f = th.getAttribute('style');
        if(f) principal.parentElement.setAttribute('style', f);
      });
    });
  }
  var cant = document.querySelector('.cantidad');
  if(cant){
    var inp = cant.querySelector('input');
    cant.querySelector('.menos').addEventListener('click', function(){ inp.value = Math.max(1, (parseInt(inp.value)||1)-1); });
    cant.querySelector('.mas').addEventListener('click', function(){ inp.value = (parseInt(inp.value)||1)+1; });
  }
})();

/* ── Reviews slider ──────────────────────────────────── */
(function(){
  'use strict';
  var cont = document.getElementById('testimonios');
  if(!cont) return;
  var frases = cont.querySelectorAll('blockquote');
  var puntos = document.getElementById('testPuntos');
  var actual = 0, timer;
  frases.forEach(function(_, i){
    var b = document.createElement('button');
    b.setAttribute('aria-label','Reseña '+(i+1));
    if(i===0) b.classList.add('activo');
    b.addEventListener('click', function(){ ir(i); reiniciar(); });
    puntos.appendChild(b);
  });
  var dots = puntos.querySelectorAll('button');
  function ir(i){
    frases[actual].classList.remove('activo'); dots[actual].classList.remove('activo');
    actual = (i+frases.length)%frases.length;
    frases[actual].classList.add('activo'); dots[actual].classList.add('activo');
  }
  function reiniciar(){ clearInterval(timer); timer=setInterval(function(){ ir(actual+1); },6000); }
  document.getElementById('testPrev').addEventListener('click', function(){ ir(actual-1); reiniciar(); });
  document.getElementById('testNext').addEventListener('click', function(){ ir(actual+1); reiniciar(); });
  if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches) reiniciar();
})();

/* ── Hero slider (latas / cola) ──────────────────────── */
(function(){
  'use strict';
  var cont = document.getElementById('heroSlider');
  if(!cont) return;
  var slides = cont.querySelectorAll('.hs-slide');
  var puntos = document.getElementById('hsPuntos');
  var seccion = document.getElementById('heroB');
  var copys = document.querySelectorAll('.hero-copy');
  var patrones = document.querySelectorAll('.hero-patron');
  var actual = 0, timer;
  slides.forEach(function(_, i){
    var b = document.createElement('button');
    b.setAttribute('aria-label','Banner '+(i+1));
    if(i===0) b.classList.add('activo');
    b.addEventListener('click', function(){ ir(i); reiniciar(); });
    puntos.appendChild(b);
  });
  var dots = puntos.querySelectorAll('button');
  function ir(i){
    slides[actual].classList.remove('activo'); dots[actual].classList.remove('activo');
    if(copys[actual]) copys[actual].classList.remove('activo');
    if(patrones[actual]) patrones[actual].classList.remove('activo');
    actual = (i+slides.length)%slides.length;
    slides[actual].classList.add('activo'); dots[actual].classList.add('activo');
    if(copys[actual]) copys[actual].classList.add('activo');
    if(patrones[actual]) patrones[actual].classList.add('activo');
    var bg = slides[actual].getAttribute('data-bg');
    if(seccion && bg) seccion.style.background = bg;
  }
  function reiniciar(){ clearInterval(timer); timer=setInterval(function(){ ir(actual+1); },5000); }
  if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches) reiniciar();

  /* Deslizar con el dedo entre banners. El CSS le dice al navegador que el eje
     horizontal es nuestro (touch-action:pan-y), así que aquí no hace falta frenar
     el scroll: los tres escuchas van en pasivo y el desplazamiento vertical de la
     página sigue intacto. */
  (function(){
    var zona = seccion || cont;
    var x0 = null, y0 = null;
    var MINIMO = 45;   // menos que esto es un toque, no un deslizamiento

    zona.addEventListener('touchstart', function(e){
      if(e.touches.length !== 1){ x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, {passive:true});

    zona.addEventListener('touchend', function(e){
      if(x0 === null) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      // Sólo cuenta si el gesto fue claramente horizontal: si no, la persona
      // estaba haciendo scroll y no queremos cambiarle el banner por accidente.
      if(Math.abs(dx) > MINIMO && Math.abs(dx) > Math.abs(dy)){
        ir(actual + (dx < 0 ? 1 : -1));
        reiniciar();
      }
    }, {passive:true});

    zona.addEventListener('touchcancel', function(){ x0 = null; }, {passive:true});
  })();
})();

/* ── Reels: hover reproduce (sin controles), al salir pausa ── */
(function(){
  'use strict';
  document.querySelectorAll('.video-ph').forEach(function(caja){
    var v = caja.querySelector('video');
    if(!v) return;
    caja.addEventListener('mouseenter', function(){
      v.muted = true; v.controls = false;
      var p = v.play(); if(p && p.catch) p.catch(function(){});
      caja.classList.add('reproduciendo');
    });
    caja.addEventListener('mouseleave', function(){
      v.pause();
      caja.classList.remove('reproduciendo');
    });
    /* En touch (sin hover): tap reproduce/pausa */
    caja.addEventListener('click', function(){
      if(window.matchMedia('(hover: hover)').matches) return;
      if(v.paused){ v.muted = true; v.play(); caja.classList.add('reproduciendo'); }
      else { v.pause(); caja.classList.remove('reproduciendo'); }
      if(!v.paused && caja.closest('#reelsPista')){
        caja.scrollIntoView({behavior:'smooth', block:'nearest', inline:'center'});
      }
    });
  });
})();

/* ── Mega menú: el destacado cambia con el sabor en hover ── */
(function(){
  'use strict';
  var dest = document.querySelector('.mega-destacado');
  if(!dest) return;
  var img = dest.querySelector('img:not(.fruta-mega)'), tag = dest.querySelector('.tag-nuevo'), b = dest.querySelector('b');
  var fruta = dest.querySelector('.fruta-mega');
  var FRUTAS = {mandarina:1, frambuesa:1, guayaba:1, manzana:1, maracuya:1, pina:1, toronja:1};
  var COL = {mandarina:['#f37435',0], maracuya:['#5f0c09',0], frambuesa:['#87162d',0],
    guayaba:['#ed7a7c',0], manzana:['#b72323',0], pina:['#feca58',1], toronja:['#faba9c',1],
    cola:['#4a2118',0], 'agua-natural':['#123d67',0], 'agua-gas':['#bce5e7',1], surtido:['#d0acd1',1]};
  var DATOS = {};
  try { var nodo = document.getElementById('megaDatos'); if(nodo) DATOS = JSON.parse(nodo.textContent); } catch(e){}
  function set(handle){
    var p = DATOS[handle];
    if(!p) return;
    dest.setAttribute('href', '/products/' + handle);
    if(p.img) img.src = p.img;
    b.textContent = (p.n || '').replace('Félix Schorle', 'Schorle').replace('®','');
    dest.style.background = p.c || '';
    dest.style.color = (p.t === 'claro') ? 'var(--semilla)' : 'var(--nata)';
    if(tag) tag.style.display = (handle === 'felix-cola') ? '' : 'none';
    if(fruta){
      if(p.f){ fruta.src = p.f; fruta.style.display = ''; }
      else fruta.style.display = 'none';
    }
  }
  document.querySelectorAll('.mega li a').forEach(function(a){
    var m = (a.getAttribute('href') || '').match(/^\/(?:products|pages)\/([a-z0-9-]+)/);
    if(!m) return;
    a.addEventListener('mouseenter', function(){ set(m[1]); });
  });
  var mega = document.querySelector('.mega');
  if(mega) mega.addEventListener('mouseleave', function(){
    set('felix-cola');
    dest.style.background = ''; dest.style.color = '';
    if(tag) tag.style.display = '';
    if(fruta) fruta.style.display = 'none';
  });
})();

/* ── Respiro garantizado antes de la cortina del footer ── */
(function(){
  'use strict';
  var cort = document.querySelector('.cortina-pie');
  if(!cort) return;
  var prev = cort.previousElementSibling;
  while(prev && (prev.tagName === 'SCRIPT' || prev.tagName === 'STYLE')) prev = prev.previousElementSibling;
  if(prev && prev.classList.contains('bloque')) prev.classList.add('pre-cortina');
})();


/* ── PDP: barra fija de compra (móvil) ───────────────── */
(function(){
  'use strict';
  var fija = document.getElementById('pdpFija');
  if(!fija) return;
  var real = document.querySelector('.agregar-pdp') || document.querySelector('.pdp-info .agregar-bundle');
  if(!real){ fija.remove(); return; }
  document.body.classList.add('con-pdp-fija');
  var src = document.getElementById('pdpPrecio'), dst = document.getElementById('pfPrecio');
  var pintar = function(){
    if(src && dst) dst.textContent = src.textContent.replace(/\s+/g,' ').replace(' MXN','').trim();
  };
  pintar();
  if(src && window.MutationObserver){
    new MutationObserver(pintar).observe(src, {childList:true, subtree:true, characterData:true});
  }
  var pdp = document.querySelector('.pdp');
  if(pdp){
    var v = getComputedStyle(pdp).getPropertyValue('--sabor');
    if(v) fija.style.setProperty('--sabor', v.trim());
  }
  var compra = document.querySelector('.pdp-compra');
  if(compra && window.IntersectionObserver){
    new IntersectionObserver(function(en){
      fija.classList.toggle('oculta', en[0].isIntersecting);
    }, {threshold: .35}).observe(compra);
  }
  var btn = document.getElementById('pfBtn');
  if(real && real.hasAttribute('data-avisar')){   /* agotado: la barra lleva al correo, no finge agregar */
    btn.textContent = (real.textContent || '').trim();
    btn.classList.add('btn-avisar');
    btn.addEventListener('click', function(){ real.click(); });
    return;
  }
  if(real && real.disabled){
    btn.disabled = true;
    btn.textContent = (real.textContent || '').trim() || 'Agotado';
    return;
  }
  btn.addEventListener('click', function(){
    real.click();
    var t = btn.textContent;
    btn.textContent = 'Agregado \u2713';
    setTimeout(function(){ btn.textContent = t; }, 1300);
  });
})();


/* ── Reels: carrusel con deriva automática (móvil) ───── */
(function(){
  'use strict';
  var pista = document.getElementById('reelsPista');
  if(!pista) return;
  var mq = window.matchMedia('(max-width:720px)');
  var tocando = false, timer = null, pos = null;
  function half(){ return pista.scrollWidth / 2; }
  if(mq.matches) pista.scrollLeft = half();
  ['touchstart','pointerdown'].forEach(function(ev){
    pista.addEventListener(ev, function(){ tocando = true; pos = null; clearTimeout(timer); }, {passive:true});
  });
  ['touchend','pointerup','pointercancel'].forEach(function(ev){
    pista.addEventListener(ev, function(){
      clearTimeout(timer);
      timer = setTimeout(function(){ tocando = false; pos = null; }, 2500);
    }, {passive:true});
  });
  function tick(){
    if(mq.matches && !tocando && !pista.querySelector('.reproduciendo')){
      if(pos === null) pos = pista.scrollLeft;
      pos -= 0.55;                       /* contenido avanza de izquierda a derecha */
      if(pos <= 0) pos += half();
      pista.scrollLeft = pos;
    }
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
})();


/* ── Galería PDP: swipe en la foto + una fila de thumbs con +N (móvil) ── */
(function(){
  'use strict';
  var marco = document.getElementById('pdpMarco'), thumbs = document.getElementById('pdpThumbs');
  if(!marco || !thumbs) return;
  var mq = window.matchMedia('(max-width:900px)');
  function decorar(){
    var bs = thumbs.querySelectorAll('.thumb');
    bs.forEach(function(b){ b.classList.remove('mas-fotos'); b.removeAttribute('data-mas'); });
    if(mq.matches && bs.length > 4){
      bs[3].classList.add('mas-fotos');
      bs[3].setAttribute('data-mas', '+' + (bs.length - 3));
    }
  }
  decorar();
  new MutationObserver(decorar).observe(thumbs, {childList:true});
  if(mq.addEventListener) mq.addEventListener('change', decorar);
  var x0 = null, y0 = null;
  marco.addEventListener('touchstart', function(e){
    x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
  }, {passive:true});
  marco.addEventListener('touchend', function(e){
    if(x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
    x0 = null;
    if(Math.abs(dx) < 42 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
    var bs = [].slice.call(thumbs.querySelectorAll('.thumb'));
    if(bs.length < 2) return;
    var i = bs.indexOf(thumbs.querySelector('.thumb.activo'));
    var j = (i + (dx < 0 ? 1 : -1) + bs.length) % bs.length;
    bs[j].click();
  }, {passive:true});
})();
